export default __webpack_public_path__ + "static/media/hamburger.2ac61841.svg";